import { buildMediaUrl } from '../Services/mediaUrl';

const buildVideoSource = (video) => video.url || video.base64 || buildMediaUrl(video, 'videos');

export const VideoRender = ({ message }) => {
  const videos =
    message.videos && message.videos.length > 0
      ? message.videos
      : message.url || message.base64File
        ? [
            {
              url: message.url,
              base64: message.base64File,
              fileName: message.fileName,
              extension: message.extension,
            },
          ]
        : [];

  if (videos.length === 0) return null;

  return (
    <>
      {videos.map((video, idx) => {
        const source = buildVideoSource(video);
        if (!source) return null;

        return (
          <div key={idx} className="video-wrapper">
            <video className="video-player" controls preload="metadata" playsInline src={source} />
            {video.fileName && <div className="video-name">{video.fileName}</div>}
          </div>
        );
      })}
    </>
  );
};
